export default "__VITE_ASSET__0b0a5090__"